import { render } from "./PersonCard.vue?vue&type=template&id=1e19e446&scoped=true&ts=true"
import script from "./personCardHelper.ts?vue&type=script&lang=ts"
export * from "./personCardHelper.ts?vue&type=script&lang=ts"

import "./PersonCard.vue?vue&type=style&index=0&id=1e19e446&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e19e446"]])

export default __exports__